//const API_BASE_URL = 'https://fibretelecom.peachpreview.co.uk/api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class ConnectionService {
  async getServiceTypes() {
    try {
      const response = await fetch(`${API_BASE_URL}/connection-options`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching service types:", error);
      throw error;
    }
  }
  async getAllConnections(params = {}) {
    try {
      // Build query string from parameters
      const queryParams = new URLSearchParams();

      const queryString = queryParams.toString();
      const url = `${API_BASE_URL}/connection-details`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching connections:", error);
      throw error;
    }
  }

  async createConnection(data) {
    try {
        const response = await fetch(`${API_BASE_URL}/connection-details`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        
        if (!response.ok) {
            // Handle different error response formats
            const errorMsg = result.message || 
                          (result.errors ? Object.values(result.errors).join(', ') : null) || 
                          "Failed to create connection";
            throw new Error(errorMsg);
        }

        // Return the entire response
        return result;
        
    } catch (error) {
        console.error("Error creating connection:", error);
        throw error;
    }
  }
 async updateConnection(id, data) {
  try {
    const response = await fetch(`${API_BASE_URL}/connection-details/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || "Failed to update");

    return result;   // ← return the whole envelope, same shape as createConnection
  } catch (error) {
    console.error("Error updating connection:", error);
    throw error;
  }
}
  async getNumberTypes() {
    try {
      const response = await fetch(`${API_BASE_URL}/number-types`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching service types:", error);
      throw error;
    }
  }
  async getContractConnections(params = {}) {
    try {
      // Build query string from parameters
      const queryParams = new URLSearchParams();

      const queryString = queryParams.toString();
      const url = `${API_BASE_URL}/contract-connection-details`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching connections:", error);
      throw error;
    }
  }

  async deleteConnection(id) {
  try {
    const response = await fetch(`${API_BASE_URL}/connection-details/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || "Failed to delete");

    return result;
  } catch (error) {
    console.error("Error deleting connection:", error);
    throw error;
  }
  }
  async getConnection(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/connection-details/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Failed to fetch connection");

      return result;   // same envelope shape as createConnection/updateConnection
    } catch (error) {
      console.error("Error fetching connection:", error);
      throw error;
    }
  }

}

const connectionService = new ConnectionService();
export default connectionService;
